import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  MoreOutlined,
  PlayCircleOutlined,
  SettingOutlined,
  EyeOutlined,
  DownloadOutlined,
  // SendOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, Tag } from 'antd';
import React from 'react';
import { BiSolidPackage } from 'react-icons/bi';

export const getMappingColumns = ({
  onTransformAll,
  onManageMapping,
  onPreviewMapping,
  onExportCSV,
  // onBroadcastProducts,
}) => [
  {
    title: 'Store',
    key: 'store',
    sorter: (a, b) =>
      String(a.store?.name || '').localeCompare(String(b.store?.name || '')),
    sortDirections: ['ascend', 'descend'],
    render: (record) => record.store?.name || '-',
  },
  {
    title: 'Category MP',
    key: 'mp_category',
    sorter: (a, b) =>
      String(a.mp_category?.name || '').localeCompare(
        String(b.mp_category?.name || '')
      ),
    sortDirections: ['ascend', 'descend'],
    render: (record) => record.mp_category?.label || '-',
  },
  {
    title: 'Mapping configuré',
    key: 'mapping_configured',
    render: (record) => {
      return record?.mapping_id ? (
        <Tag icon={<CheckCircleOutlined />} color="success">
          Oui
        </Tag>
      ) : (
        <Tag icon={<CloseCircleOutlined />} color="error">
          Non
        </Tag>
      );
    },
  },
  {
    title: 'Produits associés',
    key: 'associated_products',
    render: (record) => {
      const count = record?.product_nb;
      return count ? (
        <Tag
          icon={
            <BiSolidPackage
              style={{
                verticalAlign: 'middle',
                fontSize: 16,
                marginRight: 8,
              }}
            />
          }
          color="blue"
        >
          {count}
        </Tag>
      ) : (
        '-'
      );
    },
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 100,
    render: (record) => {
      const isShoppingFeed =
        record?.mp_category?.marketplace?.name?.toLowerCase() ===
        'shoppingfeed';

      const menuItems = [
        {
          key: 'transform-all',
          label: 'Tout transformer',
          icon: <PlayCircleOutlined />,
          disabled: !record.mapping_id,
          onClick: (e) => onTransformAll?.(e, record),
        },
        {
          key: 'manage-mapping',
          label: 'Gérer le mapping',
          icon: <SettingOutlined />,
          onClick: (e) => onManageMapping?.(e, record),
        },
        {
          key: 'preview-mapping',
          label: 'Prévisualiser le mapping',
          icon: <EyeOutlined />,
          onClick: (e) => onPreviewMapping?.(e, record),
        },
        isShoppingFeed && {
          key: 'export-csv',
          label: 'Exporter au format CSV',
          icon: <DownloadOutlined />,
          onClick: (e) => onExportCSV?.(e, record),
        },
        // isShoppingFeed && {
        //   key: 'broadcasProducts',
        //   label: 'Diffuser les produits',
        //   icon: <SendOutlined />,
        //   onClick: (e) => onBroadcastProducts?.(e, record),
        // },
      ].filter(Boolean);

      return (
        <Dropdown
          menu={{ items: menuItems }}
          trigger={['click']}
          placement="bottomRight"
        >
          <Button
            type="default"
            size="small"
            icon={<MoreOutlined />}
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    },
  },
];
